<template>
    <div class="contact__card">
        <p class="contact__card__status">{{ contactStatus }}</p>
        <h2>{{ naam }}</h2>
        <div class="contact__card__links">
            <a :href="'mailto:' + mail + '?subject=Contact Website&body=' + bericht"><i class="fa-solid fa-envelope"></i>{{ mail }}</a>
            <a :href="'tel:' + tel"><i class="fa-solid fa-phone"></i>{{ tel }}</a>
        </div>
        <div class="contact__card__bericht">
            <h3>Bericht</h3>
            <p>{{ bericht }}</p>
        </div>
        <div class="contact__card__actions">
            <h2>Status</h2>
            <div class="contact__card__actions__switch">
                <div :class="switchPosition"></div>
                <div class="contact__card__actions__switch__icon" @click="clickSucces">
                    <i class="fa-solid fa-circle-check"></i>
                </div>
                <div class="contact__card__actions__switch__icon" @click="clickBehandeling">
                    <i class="fa-solid fa-clock"></i>
                </div>
            </div>
        </div>
        <div :class="succesStatus" v-if="status.customerStats">
            <h2>Verdiensten</h2>
            <div class="contact__card__succes__actions">
                <div :class="klantStatus" @click="changeKlantStatus">
                    <i class="fa-solid fa-handshake"></i>
                </div>
                <div class="contact__card__succes__actions__input">
                    <h3>€</h3>
                    <input type="number">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:["f_id", "naam", "mail", "tel", "bericht", "contactStatus", "klant"],
    inject:['status'],
    data(){
        return{
            switchPosition: "contact__card__actions__switch__active",
            succesStatus: "contact__card__succes",
            klantStatus: "contact__card__succes__actions__button"
        }
    },
    methods:{
        clickSucces(){
            this.switchPosition =  "contact__card__actions__switch__active contact-done";
        },
        clickBehandeling(){
            this.switchPosition =  "contact__card__actions__switch__active contact-pending";
        },
        changeKlantStatus(){
            if(this.klantStatus === "contact__card__succes__actions__button contact-klant-true"){
                this.klantStatus = "contact__card__succes__actions__button";
            } else {
                this.klantStatus = "contact__card__succes__actions__button contact-klant-true";
            }
        }
    },
    created(){
        if(this.$props.contactStatus === "behandeld"){
            this.switchPosition =  "contact__card__actions__switch__active contact-done";
            this.succesStatus = "contact__card__succes contact-succes-active"
            if(this.$props.klant){
                this.klantStatus = "contact__card__succes__actions__button contact-klant-true";
            } else{
                this.klantStatus = "contact__card__succes__actions__button";
            }
        } else if(this.$props.contactStatus === "in behandeling"){
            this.switchPosition =  "contact__card__actions__switch__active contact-pending";
        }

    }
}
</script>